import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, computed, ref, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosRangePicker from '@/components/CosRangePicker/index'
import { tagsManageList, tagsManageModify, tagsManageDelete } from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import { MarketingManageParams, MarketingManageListItem } from '@/typings/api/marketingManage'
import type { SelectProps } from 'ant-design-vue'

const __default__ = { name: 'DcCosZbuTagsManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  subdomain: {
    type: String as PropType<'fbu' | 'lbu'>,
    required: true
  },
  permission: {
    type: Object as PropType<{
      add: string
      edit: string
      del: string
      enable: string
      disable: string
    }>,
    required: true
  }
},
  setup(__props) {

const router = useRouter()

const props = __props

const statusEnum = [
  { name: '启用', value: 1, color: '#3FAC46' },
  { name: '停用', value: 2, color: '#DF443B' }
]
const typeEnum = ref<SelectProps['options']>([{ value: 1, label: '静态标签' }])

const tableRef = ref()
const queryForm = reactive<MarketingManageParams>({})

const columns = computed(() => [
  {
    title: '标签名称',
    dataIndex: 'name',
    cosType: 'link',
    path: `/${props.subdomain}/tagsManage/view`,
    query: ['id'],
    fixed: 'left'
  },
  { title: '上级标签', dataIndex: 'parentName' },
  { title: '类型', dataIndex: 'type' },
  { title: '备注', dataIndex: 'remark' },
  { title: '状态', dataIndex: 'status' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 200 },
  { title: '操作', dataIndex: 'action', width: 170, fixed: 'right' }
])
const getList = (queryForm: MarketingManageParams, callBack: (res: any) => void) => {
  tagsManageList(queryForm).then((res) => {
    callBack(res)
  })
}

// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: `/${props.subdomain}/tagsManage/edit`, query: { id } })
  } else {
    router.push(`/${props.subdomain}/tagsManage/add`)
  }
}
const handleStatus = (row: MarketingManageListItem) => {
  const params = {
    id: row.id,
    status: row.status === 1 ? 2 : 1
  }
  tagsManageModify(params).then(() => {
    message.success(row.status === 1 ? '已停用' : '已启用')
    tableRef.value?.fetch()
  })
}
const handleDelete = (row: MarketingManageListItem) => {
  Modal.delete({
    name: row.name,
    onOk() {
      tagsManageDelete({ id: row.id }).then(() => {
        message.success('删除标签成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[7] || (_cache[7] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: __props.subdomain === 'fbu' ? 'DcCosFbuTagManage' : 'DcCosLbuTagManage'
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    label: "标签名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.name) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "parentName",
                    label: "上级标签"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.parentName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.parentName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "type",
                    label: "类型"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.type,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.type) = $event)),
                        options: typeEnum.value,
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "status",
                    label: "状态"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        fieldNames: { label: 'name' },
                        value: queryForm.status,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.status) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: statusEnum
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createTime",
                    label: "创建时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosRangePicker), {
                        startTime: queryForm.createTimeStart,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.createTimeStart) = $event)),
                        endTime: queryForm.createTimeEnd,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.createTimeEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              })), [
                [_directive_permission, __props.permission.add]
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 0,
                    enums: statusEnum,
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'type')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(['', '静态标签'][text]), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, __props.permission.edit]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, __props.permission.del]
                    ]),
                    (record.status === 2)
                      ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "link",
                          onClick: ($event: any) => (handleStatus(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("启用")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.enable]
                        ])
                      : _createCommentVNode("", true),
                    (record.status === 1)
                      ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "link",
                          onClick: ($event: any) => (handleStatus(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("停用")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.disable]
                        ])
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search", "tableId"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})